/* eslint-disable */
export const ComplexGenericsItems = [
  {
    "srno": 1,
    "productID": "1003",
    "rLDProduct_Dev": "Lipitor (Small) UK/ Thialand",
    "productName": "Atorvastatin Calcium Trihydarte Tablets (10, 20, 40, 80 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "To be done",
    "technologyTransfer": "To be done",
    "remark": "Scale up Plan",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": false
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 2,
    "productID": "2026",
    "rLDProduct_Dev": "Circardin (EU)",
    "productName": "Melatonin Prolong Released Tablets (2 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Done",
    "technologyTransfer": "Done",
    "remark": "Approved by EU",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": false
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 3,
    "productID": "1012",
    "rLDProduct_Dev": "Noxafil (USA)",
    "productName": "Posaconazole Delayed Release Tablets 100 mg",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Done",
    "technologyTransfer": "Done",
    "remark": "ANDA Approved",
    "avaliableIn": [
      {
        "key": "USA",
        "value": false
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 4,
    "productID": "1013",
    "rLDProduct_Dev": "Bradion (USA /EU)",
    "productName": "Sugammadex Injection 100 mg / ml ( 2 ml and 5 ml)",
    "productDevStatus": "Done",
    "pilotBE": "NA",
    "scaleUp": "Done",
    "pivotalBE": "NA",
    "technologyTransfer": "Done",
    "remark": "Approved By USFDA/ EU",
    "avaliableIn": [
      {
        "key": "USA",
        "value": false
      },
      {
        "key": "EU",
        "value": false
      },
      {
        "key": "China",
        "value": false
      },
      {
        "key": "Australia",
        "value": false
      },
      {
        "key": "S.E. Asia",
        "value": false
      },
      {
        "key": "Other",
        "value": false
      }
    ]
  },
  {
    "srno": 5,
    "productID": "2026",
    "rLDProduct_Dev": "Invega (USA/EU)",
    "productName": "Paliperidone Extended Release Tablets (1.5, 3.0, 6.0, 9.0 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready for Tech Transfer",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 6,
    "productID": "2026",
    "rLDProduct_Dev": "Ketosterile (UK)",
    "productName": "Alpha keto analogues of Essential Amino Acids Tablets",
    "productDevStatus": "Done",
    "pilotBE": "NA",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready for Tech Transfer",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 7,
    "productID": "2001",
    "rLDProduct_Dev": "Voquezna (USA), Inzelm (Brazil)",
    "productName": "Vonoprazan Fumarate 10 mg and 20 mg",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Pending",
    "technologyTransfer": "Done",
    "remark": "Submission batches done",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": false
      },
      {
        "key": "Other",
        "value": false
      }
    ]
  },
  {
    "srno": 8,
    "productID": "2004",
    "rLDProduct_Dev": "Duexis (USA)",
    "productName": "Ibuprofen and Famotidine Tablets (800+ 26.6 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Done",
    "technologyTransfer": "Done",
    "remark": "ANDA Under Review",
    "avaliableIn": [
      {
        "key": "USA",
        "value": false
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 9,
    "productID": "2005",
    "rLDProduct_Dev": "Promacta (USA), Revolade (EU)",
    "productName": "Eltrombopag Olamine Tablets (Eq to Acid)12.5, 25, 50, 75 mg",
    "productDevStatus": "Done",
    "pilotBE": "NA",
    "scaleUp": "Planned",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "EB Planned",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": false
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 10,
    "productID": "2006",
    "rLDProduct_Dev": "Promacta Kit (USA)",
    "productName": "Eltrombopag Olamine For Suspension (Eq to Acid) 12.5, 25 mg",
    "productDevStatus": "Done",
    "pilotBE": "NA",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Prototype Ready",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 11,
    "productID": "2008",
    "rLDProduct_Dev": "Slenyto (EU)",
    "productName": "Melatonin Prolong Released Tablets (1 mg and 5 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Planned",
    "scaleUp": "Planned",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Pilot BE Planned",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": false
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 12,
    "productID": "2009",
    "rLDProduct_Dev": "Hemedy (USA)",
    "productName": "Dexamethasone Tablets (20 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Done",
    "technologyTransfer": "Done",
    "remark": "ANDA Filed",
    "avaliableIn": [
      {
        "key": "USA",
        "value": false
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 13,
    "productID": "2010",
    "rLDProduct_Dev": "Adalat GITS (EU)",
    "productName": "Nefidipine Extended Release Tablets (30mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "EB batches Planned",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": false
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 14,
    "productID": "2011",
    "rLDProduct_Dev": "Forxiga (USA / EU)",
    "productName": "Dapagliflozin Tablets (5 and 10 mg)",
    "productDevStatus": "Done",
    "pilotBE": "NA",
    "scaleUp": "Done",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Stability ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": false
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 15,
    "productID": "2012",
    "rLDProduct_Dev": "XIGDUO XR (USA)",
    "productName": "Metformin Extended Release + Dapagliflozin Tablets (2.5 +1000, 5 + 500, 5 +1000, 10 + 500, 10 + 1000 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Prototype Ready",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 16,
    "productID": "2014",
    "rLDProduct_Dev": "Intelence (USA)",
    "productName": "Etraverine Tablets 25 mg, 100 mg and 200 mg",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Pilot BE Planned",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 17,
    "productID": "2015",
    "rLDProduct_Dev": "Innpopran XL (USA)",
    "productName": "Propranolol Hydrochloride ER Capsules (60, 80, 120 mg and 160 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready for Tech Trasnfer",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 18,
    "productID": "2016",
    "rLDProduct_Dev": "Pritin (USA)",
    "productName": "Rifapentine Tablets 150 mg",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Pilot Successfully Completed",
    "avaliableIn": [
      {
        "key": "USA",
        "value": false
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 19,
    "productID": "2018",
    "rLDProduct_Dev": "Innpopran XL (USA)",
    "productName": "Propranolol Hydrochloride ER Capsules (80 mg and120 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Pilot to be Planned",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 20,
    "productID": "2019",
    "rLDProduct_Dev": "Lyvispah (USA)",
    "productName": "Baclofen Oral Granules 5, 10, 20 mg",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Pilot BE Planned",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 21,
    "productID": "2020",
    "rLDProduct_Dev": "Fleqsuvy (USA)",
    "productName": "Baclofen Oral Suspension 25 mg / 5ml",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Pilot BE Planned",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 22,
    "productID": "2020",
    "rLDProduct_Dev": "OZOBAX (USA)",
    "productName": "Baclofen Oral Solution 5mg / 5ml",
    "productDevStatus": "Done",
    "pilotBE": "N/A",
    "scaleUp": "Pending",
    "pivotalBE": "N/A",
    "technologyTransfer": "Pending",
    "remark": "Ready for Tech Transfer",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 23,
    "productID": "3001",
    "rLDProduct_Dev": "Concerta (USA/EU), RELEXXII",
    "productName": "Methylphenedate Extended Release Tablets 18, 27, 36, 45, 54, 63 and 72 mg",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Planned",
    "technologyTransfer": "Pending",
    "remark": "Successful Pilot BE Using Matrix Formulation Tech Transfer Planned",
    "avaliableIn": [
      {
        "key": "USA",
        "value": false
      },
      {
        "key": "EU",
        "value": false
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 24,
    "productID": "3004",
    "rLDProduct_Dev": "Xeljanz XR (USA / EU)",
    "productName": "Tofacitinib Extended Release Tablets (11 and 22 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready for Pilot BE. Non Infringing Composition",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 25,
    "productID": "3006",
    "rLDProduct_Dev": "Finoglide (USA)/ RS(USA)",
    "productName": "Fenofibrate Tablets 40, 120 mg",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Pilot BE Done. Ready for Tech Transfer",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 26,
    "productID": "3007",
    "rLDProduct_Dev": "Lupin (RS) (USA)",
    "productName": "Orphenadrine Citrate Extended Release 100 mg",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Done",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready for Filing with USFDA",
    "avaliableIn": [
      {
        "key": "USA",
        "value": false
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 27,
    "productID": "3008",
    "rLDProduct_Dev": "Intuniv XR (EU / Canada / Australia)",
    "productName": "Guanfacine HCL ER Tablet 1, 2, 3, 4 mg",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "EB Ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": false
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": false
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 28,
    "productID": "3010",
    "rLDProduct_Dev": "NURTEC ODT(USA)",
    "productName": "Rimegepant Orally disintegrating Tablets (75mg)",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready for Pilot BE",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 29,
    "productID": "3011",
    "rLDProduct_Dev": "Lialda (USA/ EU)",
    "productName": "Mesalamine DR Tablets (1.2 gm)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "6 M Stability and Scale Up done.",
    "avaliableIn": [
      {
        "key": "USA",
        "value": false
      },
      {
        "key": "EU",
        "value": false
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 30,
    "productID": "3013",
    "rLDProduct_Dev": "Pentasa (USA)",
    "productName": "Mesalamine Extended Release Capsules (250 and 500 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Done",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "6 M Stability done. Encouraging Pilot BE",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 31,
    "productID": "3016",
    "rLDProduct_Dev": "Generics",
    "productName": "Pyrimethamine/sulfadoxine + Amodiaquine (hydrochloride) 12.5 mg/250 mg+76.5 mg 25 mg/500 mg+153 mg Dispersible tablets.",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready For Tech Trasfer",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 32,
    "productID": "3017",
    "rLDProduct_Dev": "Agumentin (EU)",
    "productName": "Amoxycilline + Potassium Clavunate Tablets  (250/125, 500/125 , 875/125 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Aqueous Coating. Ready For Tech Trasfer",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 33,
    "productID": "3018",
    "rLDProduct_Dev": "Tabex (EU)",
    "productName": "Cytisine Tablets (1.5 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready For TT",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 34,
    "productID": "3020",
    "rLDProduct_Dev": "DOLAMIN FLEX (BRAZIL)",
    "productName": "Lysine Clonixinate and Cyclobenzaprine HCL Tablets (150 mg+ 5 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready For Pilot BE",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": false
      }
    ]
  },
  {
    "srno": 35,
    "productID": "3022",
    "rLDProduct_Dev": "MYRBETRIQ (USA) /BETMIGA (GERMANY)",
    "productName": "Mirabegron ER Tablets (25, 50 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Ongoing",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready For Tech Transfer",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": false
      }
    ]
  },
  {
    "srno": 36,
    "productID": "3023",
    "rLDProduct_Dev": "DONAREN RETARD (BRAZIL) / TRITTICO CR (EU)",
    "productName": "Trazadone CR Tablets (75 , 150 mg) 12 Hrs",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Ongoing",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready For Tech Transfer",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": false
      }
    ]
  },
  {
    "srno": 37,
    "productID": "3023",
    "rLDProduct_Dev": "TRITTICO XR (EU)",
    "productName": "Trazadone XR Tablets (150 , 300 mg) 24 Hrs",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready for Pilot BE",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": false
      }
    ]
  },
  {
    "srno": 38,
    "productID": "3028",
    "rLDProduct_Dev": "Veozah (USA)",
    "productName": "Fezolinetant Tablets (45 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready For Pilot BE",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 39,
    "productID": "3029",
    "rLDProduct_Dev": "Rezdiffra (USA)",
    "productName": "Resmetirom Tablets (60, 80 and 100 mg)",
    "productDevStatus": "Ongoing",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "First To File Opprtunity",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 40,
    "productID": "3030",
    "rLDProduct_Dev": "Cymbalta (Usa / Brazil)",
    "productName": "Duloxein Delayed Release Capsules 20,30, 40 and 60 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Nitrosamine Free",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 41,
    "productID": "2031",
    "rLDProduct_Dev": "Entresto (USA)",
    "productName": "Sacubitril + Valsartan Tablet, 24+26mg, 49+51mg & 97+103mg",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Development Ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 42,
    "productID": "2032",
    "rLDProduct_Dev": "Nexlizet (USA)",
    "productName": "Bempedoic Acid + Ezetimibe Tablets (180 mg + 10 mg)",
    "productDevStatus": "Ongoing",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Development Ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 43,
    "productID": "2033",
    "rLDProduct_Dev": "Nexletol (USA)",
    "productName": "Bempedoic Acid Tablets (180 mg)",
    "productDevStatus": "Ongoing",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Development Ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 44,
    "productID": "2034",
    "rLDProduct_Dev": "Vraylar (USA)",
    "productName": "Cariprazine Hydrochloride Capsules (1.5 mg, 3 mg, 4.5 mg, 6 mg)",
    "productDevStatus": "Ongoing",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Development Ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 45,
    "productID": "2035",
    "rLDProduct_Dev": "Glyxambi (USA)",
    "productName": "Empagliflozin + Linagliptin (10+5 mg, 25+5 mg)",
    "productDevStatus": "Ongoing",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Development Ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 46,
    "productID": "2036",
    "rLDProduct_Dev": "Gemtesa (USA)",
    "productName": "Vibegron Tablets 75 mg",
    "productDevStatus": "Ongoing",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Development Ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 47,
    "productID": "2037",
    "rLDProduct_Dev": "Aspen (EU RLD)",
    "productName": "Fludrocotisone Tablets 50 and 100 mcg",
    "productDevStatus": "Done",
    "pilotBE": "NA",
    "scaleUp": "Ongoing",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Tech Trasnfer Ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": false
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  }
];
